<div class="form-templates">
  <a
    (click)="whatsappTemplatesService.navigateToList()"
    class="arrow arrow-left"
    [translate]="'parameters/whatsapp-templates/details/back'"></a>

  <div class="warning-can-not-edit" *ngIf="template && !template.isElementEditable">
    <mat-icon> info_outline </mat-icon>&nbsp;
    <span translate="parameters/whatsapp-templates/details/can-not-edit"></span>
  </div>

  <mat-card>
    <mat-card-title translate="parameters/whatsapp-templates/details/main/title"></mat-card-title>
    <mat-card-subtitle>
      <span translate="parameters/whatsapp-templates/description-1"></span><br />
      <span translate="parameters/whatsapp-templates/description-3"></span>&nbsp;
      <a
        href="https://developers.facebook.com/docs/whatsapp/api/messages/message-templates/"
        rel="noopener noreferrer nofollow"
        target="_blank"
        >https://developers.facebook.com/docs/whatsapp/api/messages/message-templates/</a
      >
    </mat-card-subtitle>
    <mat-card-content>
      <app-whatsapp-template-main [form]="mainForm" [template]="template"></app-whatsapp-template-main>
    </mat-card-content>
  </mat-card>

  <mat-card *ngIf="!create && template">
    <mat-card-title translate="parameters/whatsapp-templates/details/scenarios-dependencies/title"></mat-card-title>
    <mat-card-content>
      <app-whatsapp-template-scenarios-dependencies
        [template]="template"></app-whatsapp-template-scenarios-dependencies>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-title translate="parameters/whatsapp-templates/details/category/title"></mat-card-title>
    <mat-card-content>
      <app-whatsapp-template-category [form]="form"></app-whatsapp-template-category>
    </mat-card-content>
  </mat-card>

  <ng-container
    *ngIf="
      form.get('main').get('languages')?.value.length &&
      form.get('main').get('languages').value[0] &&
      templatesLanguageActive?.length
    ">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" (selectedTabChange)="selectedIndexChange($event)">
      <ng-container *ngFor="let templateControl of templatesLanguageActive">
        <mat-tab>
          <ng-template matTabLabel><span [translate]="templateControl.get('code').value"></span></ng-template>
          <app-whatsapp-template-languages
            [create]="create"
            [form]="templateControl"
            [template]="template"
            [agentShortcuts]="agentShortcuts"></app-whatsapp-template-languages>
        </mat-tab>
      </ng-container>
    </mat-tab-group>
  </ng-container>
</div>
<div class="message-preview">
  <app-whatsapp-template-preview
    [templateDisplayedBS]="templateDisplayedBS"
    [settingsMode]="true"></app-whatsapp-template-preview>
</div>
